import { useEffect, useState } from "react"
import "./css/Header.css"
import { Link, useNavigate } from "react-router-dom"
import { Button, Container } from "@mui/material"
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { AppBlocking } from "@mui/icons-material";
import { v4 as uuid } from "uuid";
import { toast } from "react-toastify";

const Header = () => {
    const [activeTab, setActiveTab] = useState(0)
    let path = window.location.pathname

    if (path.includes("/crm/mailbox")) {
        path = "/crm/mailbox"
    }
    else if (path.includes("/crm/accounting")) {
        path = "/crm/accounting"
    }

    const navigate = useNavigate()

    const redirect = {
        "/crm": {
            text: "Leads"
        },
        "/crm/mailbox": {
            text: "Mailbox"
        },
        "/crm/forms": {
            text: "Forms"
        },
        "/crm/leads/leads-view": {
            text: "Leads"
        },
        "/crm/leads/leads-pipe-view": {
            text: "Leads"
        },
        "/crm/accounting": {
            text: "Accounting"
        }
    }

    const links = [
        {
            name: "Category",
            redirect: "/Category"
        },
        {
            name: "Products",
            redirect: "/Products"
        },
        {
            name: "Employee",
            redirect: "/Employee"
        },
        {
            name: "Leads",
            redirect: "/leads/leads-pipe-view"
        },
        {
            name: "Orders",
            redirect: "/Orders"
        },
        // {
        //     name: "Mailbox",
        //     redirect: "/mailbox"
        // },
        // {
        //     name: "Accounting",
        //     redirect: "/accounting"
        // }
    ]

    // Set active tab when page is refreshed
    useEffect(() => {
        const page = redirect[path] && redirect[path].text

        if (page) {
            links.forEach((item, index) => {
                if (item.name === page) {
                    setActiveTab(index)
                }
            })
        }
    }, [path])
    const domain = localStorage.getItem("domain");


    const handleButtonClick = () => {

        if (domain) {
            window.location.href = "https://" + domain + "?refresh=" + uuid()
        }
        else {
            console.error("Domain not found in local storage.");
        }
    };
    return (
        <div className="top_menu_bar" style={{ width: '100%' }}>
            <div className="_6lqg">
                <div className="tanyard-dibs main-buttons">
                    {/* <div className="back_button">
                        <Button onClick={() => {
                            localStorage.clear('token');
                            navigate('/login_page');
                            toast.success('Logout Successfull');
                        }}>Logout</Button>
                    </div> */}
                    <h4>{redirect[path] && redirect[path].text}</h4>
                </div>
                <div className="mouflons-ohm">
                    <div id="_4skl-support--ticket">
                    </div>
                </div>
            </div>
            <div className="_1nlg">
                {links.map((link, index) => {
                    return (
                        <button
                            key={index}
                            onClick={() => {
                                setActiveTab(index)
                                navigate(link.redirect)
                            }}
                            className={index === activeTab ? "active" : undefined}
                        >
                            {link.name}
                        </button>
                    )
                })}
            </div>
        </div>
    )
}

export default Header
